import React, { FC } from 'react';
import Helmet from 'react-helmet';
import { createGlobalStyle } from 'styled-components';

// `@layer base`, alongside the @nitty reset and globals (see
// nitty/cssReset.ts): keeping every global in the same layer preserves their
// relative order, and so the existing cascade between them.
const GlobalStyle = createGlobalStyle`
    @layer base {
        body {
            font-family: 'Montserrat', sans-serif;
            font-weight: 300;
        }
    }
`;

const Montserrat: FC = () => (
    <>
        <Helmet>
            <link rel="preconnect" href="https://fonts.googleapis.com" />
            <link
                rel="preconnect"
                href="https://fonts.gstatic.com"
                crossOrigin=""
            />
            <link
                href="https://fonts.googleapis.com/css2?family=Montserrat:wght@100;200;300;400;500;600;700;800&display=swap"
                rel="stylesheet"
            />
        </Helmet>
        <GlobalStyle />
    </>
);

export default Montserrat;
